"use client";

import React from "react";
import { type FollowupQuery } from "@/lib/followup-parser";

interface FollowupQueryButtonProps {
  query: FollowupQuery;
  onClick: (decodedQuery: string) => void;
  disabled: boolean;
}

export default function FollowupQueryButton({ query, onClick, disabled }: FollowupQueryButtonProps) {
  return (
    <button
      onClick={() => onClick(query.decoded)}
      disabled={disabled}
      className="group max-w-full cursor-pointer rounded-lg border border-gray-200 bg-white px-4 py-2 text-left text-gray-800 shadow-sm transition-all duration-200 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gray-200 disabled:hover:bg-white disabled:hover:shadow-sm"
      title={query.decoded} // Show full text on hover
    >
      <span className="block break-words text-sm font-normal">
        {query.display}
      </span>
    </button>
  );
}
